import React from 'react';
import { inject } from 'mobx-react';
import ReactMarkdown from 'react-markdown';

function CommentParagraph({ children }) {
  return <span>{children}</span>;
}

function buildCommentComponents($runbook, $kaizen) {
  function CommentAnchor({ href, children }) {
    const sessionId = $runbook.getAiAdvisorSessionId(href);
    if (sessionId) {
      const openInCopilot = (event) => {
        event.preventDefault();
        $kaizen.openSessionInCopilot(sessionId);
      };

      return (
        <a href={href} onClick={openInCopilot}>
          {children}
        </a>
      );
    }

    return <span>{children}</span>;
  }
  return { p: CommentParagraph, a: CommentAnchor };
}

/**
 * Renders a runbook comment as constrained markdown, turning any embedded AI Advisor
 * session links into links that open the session in Copilot.
 */
const RunbookComment = inject(
  '$kaizen',
  '$runbook'
)(({ comment, $kaizen, $runbook, fallback = 'No comment provided' }) => {
  if (!comment) {
    return fallback;
  }

  const components = buildCommentComponents($runbook, $kaizen);

  return (
    <ReactMarkdown
      components={components}
      allowedElements={['a', 'code', 'del', 'em', 'p', 'strong']}
      unwrapDisallowed
      skipHtml
    >
      {comment}
    </ReactMarkdown>
  );
});

export default RunbookComment;
